import { render, staticRenderFns } from "./index6.vue?vue&type=template&id=1b5b0824&scoped=true&"
import script from "./index6.vue?vue&type=script&lang=js&"
export * from "./index6.vue?vue&type=script&lang=js&"
import style0 from "./index6.vue?vue&type=style&index=0&id=1b5b0824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b0824",
  null
  
)

export default component.exports